import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { validationDisplayData } from "#modules/quoteRequestLines/ValidateMenuItem";
import { useValidateCosting } from "#modules/quoteRequestLines/views/useValidateCosting";
import { Icon } from "#shared/icons/Icon";
import { Button } from "#shared/view/designSystem/Button";
import { Tooltip } from "#shared/view/designSystem/Tooltip";

interface Props {
  quoteRequestLine:
    | Pick<QuoteRequestLineDto, "id" | "isReliable" | "quoteRequestId">
    | undefined
    | null;
  onValidate?: () => void;
}

export const ValidateButton = ({ quoteRequestLine, onValidate }: Props) => {
  const { validateCosting } = useValidateCosting(quoteRequestLine?.quoteRequestId, {
    onSuccess: onValidate,
  });

  const { validateIcon, validateTooltipMessage, validateMenuItemText, validateColor } =
    validationDisplayData(quoteRequestLine?.isReliable);

  if (!quoteRequestLine) {
    return null;
  }

  return (
    <Tooltip
      multiline
      w={250}
      label={validateTooltipMessage}
      transitionProps={{ transition: "fade", duration: 400 }}
    >
      <Button
        onClick={() => validateCosting(quoteRequestLine.id)}
        leftSection={<Icon name={validateIcon} />}
        size="sm"
        color={validateColor}
        variant={!quoteRequestLine.isReliable ? "filled" : "outline"}
      >
        {validateMenuItemText}
      </Button>
    </Tooltip>
  );
};
